import apiClient from './client';
import { AuthResponse, LoginCredentials, User } from '@/types';

export const authApi = {
  login: (credentials: LoginCredentials) =>
    apiClient.post<{ success: boolean; data: AuthResponse }>('/auth/login', credentials),

  register: (data: { name: string; email: string; password: string }) =>
    apiClient.post<{ success: boolean; data: AuthResponse }>('/auth/register', data),

  logout: () =>
    apiClient.post<{ success: boolean; message: string }>('/auth/logout'),

  refreshToken: (refreshToken: string) =>
    apiClient.post<{ success: boolean; data: { accessToken: string; refreshToken: string } }>('/auth/refresh', { refreshToken }),

  getMe: () =>
    apiClient.get<{ success: boolean; data: User }>('/auth/me'),

  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    apiClient.put<{ success: boolean; message: string }>('/auth/change-password', data),
};
